<template>
  <div
    class="page-loader d-flex align-items-center justify-content-center"
    id="page-loader"
    v-if="pageLoading"
  >
    <svg
      width="1290"
      height="469"
      viewBox="0 0 1290 469"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        ref="logo-path"
        d="M132.151 412.18L105.471 365.84C131.451 320.2 158.131 274.56 184.111 228.92L158.131 183.28C131.451 228.92 105.471 274.56 78.7806 320.2L52.8006 274.56C78.7806 228.22 105.461 183.28 131.441 136.93L105.461 91.99C78.7806 137.63 52.8006 183.27 26.8206 228.91L0.140625 183.27L105.471 0L236.781 228.91L132.151 412.18Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M500.801 229.61C429.881 229.61 359.661 229.61 289.441 229.61L210.801 366.54C263.461 366.54 316.131 366.54 368.791 366.54L342.811 412.18C290.151 412.18 237.481 412.18 184.121 412.18L158.141 457.82H368.791L448.141 320.9C395.481 320.9 342.811 320.9 289.451 320.9L316.131 275.26C368.791 275.26 421.461 275.26 474.121 275.26L500.801 229.61Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M263.461 183.97L158.131 0.699997H210.791C236.771 46.34 263.451 92.69 289.431 138.33H342.091C316.111 92.69 290.131 46.34 263.451 0.699997H421.441L526.771 183.97H263.461ZM448.131 138.33L395.471 46.34H342.811L395.471 138.33H448.131V138.33Z"
      />
      <path
        d="M616.46 419.05H650.06C650.06 446.27 630.07 468.42 605.5 468.42H575.94C551.37 468.42 531.37 446.27 531.37 419.05C531.37 404.75 536.92 391.89 545.72 382.87C545.71 382.86 545.71 382.86 545.71 382.86C533.67 369.98 526.22 352.23 526.22 332.68C526.22 303.9 542.4 279.04 565.58 268L551.57 256.97L572.35 230.57L620.18 268.22H620.19C620.21 268.22 620.2 268.23 620.21 268.24L620.25 268.27C643.09 279.47 659 304.11 659 332.67C659 371.81 629.21 403.62 592.64 403.62C590.57 403.62 588.55 403.51 586.54 403.28C586.51 403.27 586.48 403.27 586.44 403.26H575.94C570.1 403.26 564.98 410.63 564.98 419.03C564.98 427.43 570.1 434.8 575.94 434.8H605.5C611.34 434.82 616.46 427.46 616.46 419.05ZM559.83 332.68C559.83 351.64 572.29 367.3 588.33 369.68H596.95C612.94 367.3 625.4 351.64 625.4 332.68C625.4 312.13 610.67 295.38 592.64 295.38C574.56 295.39 559.83 312.13 559.83 332.68Z"
      />
      <path
        d="M796.62 332.68C796.62 332.7 796.62 401.98 796.62 402H763.02V394.34C753.39 400.28 742.19 403.64 730.27 403.64C693.65 403.64 663.85 371.83 663.85 332.69C663.85 293.6 693.64 261.79 730.27 261.79C742.19 261.79 753.39 265.15 763.02 271.09V262.58H796.62V332.64C796.62 332.66 796.62 332.66 796.62 332.68ZM763.02 332.62C762.99 312.1 748.28 295.38 730.27 295.38C712.18 295.38 697.45 312.12 697.45 332.68C697.45 353.29 712.18 370.03 730.27 370.03C748.28 370.03 763 353.32 763.02 332.74V332.62Z"
      />
      <path
        d="M1037.3 327.55V402H1003.7V327.55C1003.7 310.4 989.74 296.45 972.59 296.45C955.44 296.45 941.49 310.41 941.49 327.55V402H907.89V327.55C907.89 310.4 893.93 296.45 876.78 296.45C859.63 296.45 845.68 310.41 845.68 327.55V402H812.08V262.58H845.68V270.85C854.91 265.76 865.52 262.85 876.78 262.85C895.78 262.85 912.84 271.13 924.69 284.21C936.53 271.13 953.59 262.85 972.59 262.85C1008.27 262.84 1037.3 291.87 1037.3 327.55Z"
      />
      <path
        d="M1173.48 349.54L1082.59 349.26C1088.25 360.24 1099.11 368.58 1111.6 370.15C1129.86 372.45 1143.52 358.61 1145.03 356.99L1169.5 380C1165.47 384.31 1145.31 404.02 1115.79 404.02C1113.05 404.02 1110.25 403.85 1107.33 403.52C1072.33 399.04 1044.89 367.96 1044.89 332.68C1044.89 313.25 1053.07 293.48 1066.79 279.81C1078.61 268.1 1093.73 261.94 1109.58 261.78C1126.33 261.89 1142.29 268.95 1154.49 281.66C1167.59 295.27 1174.71 314.08 1174.03 333.29L1173.48 349.54ZM1137.41 315.83C1135.67 311.8 1133.27 308.1 1130.24 304.97C1124.36 298.81 1116.97 295.45 1109.35 295.39C1100.78 295.45 1094.29 299.87 1090.48 303.68C1087.12 306.98 1084.32 311.13 1082.3 315.66L1137.41 315.83Z"
      />
      <path
        d="M1282.83 382C1275.08 394.47 1260.32 402.51 1242.34 404.08C1240.27 404.26 1238.21 404.35 1236.18 404.35C1218.68 404.35 1202.6 397.81 1192.3 386.29C1183.97 376.97 1179.46 364.51 1179.26 350.26L1212.86 349.79C1212.92 354 1213.74 359.87 1217.36 363.9C1221.7 368.76 1230.37 371.4 1239.43 370.6C1247.37 369.91 1252.7 366.83 1254.29 364.27C1255.2 362.81 1256.61 358.78 1255.15 355.68C1253.06 351.24 1242.3 349.01 1232.82 347.04C1216.46 343.65 1196.09 339.43 1187.08 319.66C1180.67 305.6 1183.92 290.93 1189.1 281.89C1196.58 268.81 1211.56 260.03 1229.18 258.39C1247.9 256.67 1265.59 263.23 1276.47 276.01C1283.41 284.16 1287.31 294.91 1287.73 307.1L1254.15 308.28C1254.04 305.12 1253.38 300.73 1250.89 297.8C1247.21 293.48 1239.93 291.13 1232.3 291.86C1225.87 292.46 1220.24 295.16 1218.27 298.59C1217.71 299.56 1216.4 302.97 1217.67 305.74C1219.61 310 1230.25 312.21 1239.65 314.16C1255.98 317.54 1276.3 321.75 1285.55 341.37C1292.71 356.58 1288.56 372.77 1282.83 382Z"
      />
    </svg>
  </div>
</template>

<script>
import AOS from "aos";
export default {
  name: "pageLoader",
  data() {
    return {
      pageLoading: true,
    };
  },
  mounted() {
    window.addEventListener("load", () => {
      let logoPath = this.$refs["logo-path"];
      // to make sure that the page is loaded and the logo animation finish at least one iteration
      logoPath.addEventListener("animationiteration", () => {
        this.pageLoading = false;
        AOS.init({
          duration: 800,
          once: true,
        });
      });
    });
  },
};
</script>
